export type BuildProgressStatus = 'queued' | 'building' | 'encrypting' | 'stale';

export interface IBuild {
	id: string;
	profileId: number;
	appIcon: string | null;
	appName: string | null;
	applicationId: string | null;
	url: string | null;
	hideToGp: boolean | null;
	hideIcon: boolean | null;
	testBuild?: boolean | null;
	skipEncrypt?: boolean | null;
	androidProjectDir?: string | null;
	inQueue: boolean | null;
	successBuilded: boolean | null;
	isBuilding: boolean | null;
	cancelled: boolean | null;
	clientsCount: number;
	createdAt: string;
	hasApk: boolean;
	hasBuildLog?: boolean;
	failureMessage?: string | null;
	canCancel?: boolean;
	builderStage?: string | null;
	builderBusy?: boolean;
	progressStatus?: BuildProgressStatus | null;
}

export function isActiveBuild(build: IBuild) {
	return Boolean(build.inQueue || build.isBuilding);
}

export function getActiveBuild(builds: IBuild[]) {
	return builds.find(isActiveBuild) ?? null;
}
